import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { flushSync } from 'react-dom';

const ThemeContext = createContext<any>(null);

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved === 'dark';
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  /**
   * Akıcı tema geçişi — View Transitions API.
   *
   * Tarayıcı destekliyorsa eski/yeni snapshot arasında 220ms'lik bir
   * crossfade çalıştırır. `flushSync` ile React'a class değişimini
   * transition snapshot'ı içinde uygulattığımızdan ekran "donması"
   * yerine yumuşak bir geçiş hissedilir.
   *
   * Desteklemeyen tarayıcı (Firefox, eski Safari): klasik anında toggle.
   */
  const toggleTheme = useCallback(() => {
    const doc: any = typeof document !== 'undefined' ? document : null;
    const reduce =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!doc || reduce || typeof doc.startViewTransition !== 'function') {
      setIsDark((prev) => !prev);
      return;
    }

    doc.startViewTransition(() => {
      flushSync(() => setIsDark((prev) => !prev));
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}


